module.exports = __webpack_public_path__ + "img/dropdown-menu-solution-5-1.01d9b342.png";